export default __webpack_public_path__ + "f010eb14d5f1975f3d1a8bd49c8c589c.svg";